export default __webpack_public_path__ + "static/media/Mobile-Slide-4.0ad66fc6.jpg";